import { render, staticRenderFns } from "./TblDHRDetail.vue?vue&type=template&id=07ca43d9&scoped=true&"
import script from "./TblDHRDetail.vue?vue&type=script&lang=js&"
export * from "./TblDHRDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblDHRDetail.vue?vue&type=style&index=0&id=07ca43d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca43d9",
  null
  
)

export default component.exports